import script from "./PayInvoice.vue?vue&type=script&setup=true&lang=ts"
export * from "./PayInvoice.vue?vue&type=script&setup=true&lang=ts"

import "./PayInvoice.vue?vue&type=style&index=0&id=bdb3d7ba&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bdb3d7ba"]])

export default __exports__